<template>
    <section class="project-step project-step3-container mgt-3 mgb-3">
        <div class="container-fluid">
            <div class="custom-container">
                <div class="return-btn-container">
                    <a :href="getBackLink()">
                        <i class="fad fa-long-arrow-alt-left"></i>
                        <span> Inapoi </span>
                    </a>
                </div>
                <h6 class="link-lookalike"> {{project.name}} </h6>
                <div class="section-heading">
                    <i class="fad fa-layer-plus"></i>
                    <h1 class="m-color">
                        Adauga disponibilitate - {{model.type === 'commercial' ? 'Spaţiu Comercial' : ''}}
                        {{model.type === 'house' ? 'Casa' : ''}}
                        {{model.type === 'apartment' ? 'Apartament' : ''}}
                        {{model.rooms_count ? model.rooms_count.name: ''}}
                        tip {{ model.model_type }}

                    </h1>
                </div>
                <form class="step-form general-form">
                    <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                            <h5 class="m-color">
                                Alege un bloc unde vrei sa adaugi acesta oferta
                            </h5>
                        </div>
                        <div class="row w-100 customBlocksTabsContainer">
                            <div class="col-xl-10 col-lg-10 col-md-10 col-10">
                                <div class="blocks-tabs" role="tablist">
                                    <p :id="'block' + building.id" v-for="(building, index) in buildings"
                                       :key="`block-${index}`" style="position: relative;">
                                        <a :id="'building' + building.id" data-toggle="tab"
                                           :href="'#building' + building.id" role="tab"
                                           :aria-controls="'building' + building.id" aria-selected="true"
                                           :class="{active:building.isActive, show:building.isActive}"
                                           @click.stop.prevent="setActive(building)">
                                            <i class="fad fa-building"></i>
                                            <span> Bloc {{building.title}} </span>
                                            <span class="text-checkbox-counter" data-toggle="tooltip" data-placement="top" title="Numar apartamente">{{ buildingOffers(building) }}</span>
                                        </a>
                                    </p>
                                </div>
                            </div>
                            <div class="col-xl-2 col-lg-2 col-md-2 col-2">
                                <button type="button" class="general-btn positive-btn float-right"
                                        @click="openAddBuildingModal(project.id)">
                                    <i class="fad fa-plus-circle"></i>
                                    <span> Adauga bloc </span>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                                <div class="blocks-tabs-content tab-content">
                                    <div v-for="(building, indexBuilding) in buildings"
                                         :key="`building-${indexBuilding}`"
                                         class="tab-pane fade"
                                         :class="{active:building.isActive, show:building.isActive}"
                                         :id="'building' + building.id"
                                         role="tabpanel"
                                         :aria-labelledby="'building' + building.id + '-tab'"
                                    >
                                        <h5>
                                            {{ model.rooms_count ? model.rooms_count.name : ''}}
                                            tip {{ model.model_type }} - Total oferte: {{ buildingOffers(building) }}
                                        </h5>
                                        <h6>
                                            Adauga acesta oferta la etajul dorit folosind
                                            <i class="fad fa-plus-circle"></i> Adauga sau
                                            <i class="fad fa-trash-alt"></i> pentru a sterge.
                                        </h6>
                                        <div class="levels-container">
                                            <div class="single-level-wrapper"
                                                 v-for="(level, indexLevel) in building.levels"
                                                 :key="`level-${indexLevel}`">
                                                <h3> {{level.title}} ({{ level.itemRows.length }} oferte) </h3>
                                                <div class="add-field-btn"
                                                     @click="addItemRow(level.itemRows)">
                                                    <i class="fad fa-plus-circle"></i> Adauga
                                                </div>
                                                <div class="single-level-row"
                                                     v-for="(itemRow, indexItem) in level.itemRows"
                                                     :key="`row-${indexItem}`">
                                                    <div class="row">
                                                        <div class="col-xl-1 col-lg-2 col-md-6 col-sm-6 col-6">
                                                            <div class="level-item-nr level-strip-cell">
                                                                <p class="level-cell-heading" v-if="model.type === 'commercial'"> Nr. Spaţiu </p>
                                                                <p class="level-cell-heading" v-else> Nr. Ap </p>
                                                                <div class="input-container">
                                                                    <div class="input-group">
                                                                        <input type="text" v-model="itemRow.apartmentNumber">
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-xl-2 col-lg-2 col-md-6 col-sm-6 col-6">
                                                            <div class="level-strip-cell">
                                                                <p class="level-cell-heading"> Model </p>
                                                                <p class=""> {{model.rooms_count ?
                                                                    model.rooms_count.name : ''}}
                                                                    tip {{model.model_type}} </p>
                                                            </div>
                                                        </div>
                                                        <div class="col-xl-3 col-lg-8 col-md-12 col-sm-12 col-12">
                                                            <p class="level-cell-heading"> Suprafata(m²) </p>
                                                            <div class="custom-surface-col">
                                                                <div class="level-item-size level-strip-cell">
                                                                    <div class="input-container">
                                                                        <div class="input-group mg-b">
                                                                            <input type="number" v-model="itemRow.usefulSurface">
                                                                            <span> Totala </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="level-item-size level-strip-cell">
                                                                    <div class="input-container">
                                                                        <div class="input-group mg-b">
                                                                            <input type="number" v-model="itemRow.terraceSurface">
                                                                            <span> Balcon </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6 col-12 ml-auto">
                                                            <div class="level-item-size level-strip-cell">
                                                                <p class="level-cell-heading"> * Pret </p>
                                                                <div class="input-container">
                                                                    <div class="input-group mg-b">
                                                                        <input type="number" v-model="itemRow.price">
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6 col-12 ml-auto">
                                                            <div class="level-item-size level-strip-cell">
                                                                <p class="level-cell-heading"> Pret cu credit </p>
                                                                <div class="input-container">
                                                                    <div class="input-group mg-b">
                                                                        <input type="number" v-model="itemRow.credit_price">
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6 col-12">
                                                            <div class="level-item-size level-strip-cell">
                                                                <p class="level-cell-heading"> * Status </p>
                                                                <div class="input-container">
                                                                    <div class="input-group mg-b">
                                                                        <select name="rooms" v-model="itemRow.status">
                                                                            <option value="available"> Disponibil</option>
                                                                            <option value="reserved"> Rezervat</option>
                                                                            <option value="sold"> Vandut</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="remove-field-btn">
                                                        <i class="fad fa-trash-alt"
                                                           v-on:click="removeItemRow(indexItem, level.itemRows)"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <h5>
                                            {{ model.rooms_count ? model.rooms_count.name : ''}}
                                            tip {{ model.model_type }} - Total oferte: {{ buildingOffers(building) }}
                                        </h5>
                                        <h6>
                                            Adauga acesta oferta la etajul dorit folosind
                                            <i class="fad fa-plus-circle"></i> Adauga sau
                                            <i class="fad fa-trash-alt"></i> pentru a sterge.
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-12 col-lg-12 col-md-12 col-12" v-if="activeTab.id">
                            <div class="center-content mt-3 save-btn">
                                <button type="button" class="general-btn positive-btn" @click="save()">
                                    <i class="fad fa-save"></i>
                                    <span> Salveaza </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <!-- Modal -->
        <add-block-modal></add-block-modal>
    </section>
</template>

<script>
import AddBlockModal from './partials/AddBlockModal'

export default {
    name: "AddProjectStep3",
    props: ['project', 'model', 'buildingsDefault'],
    components: {
        AddBlockModal: AddBlockModal
    },
    data() {
        return {
            activeTab: {},
            buildings: []
        }
    },
    async mounted() {
        let vm = this;
        await this.buildingsDefault.forEach(function (building) {
            let buildingFormat = {
                title: building.name,
                id: building.id,
                levels: [],
                isActive: false
            }
            building.levels.forEach(function (level) {
                let items = vm.model.items.filter(i => i.level_id === level.id && i.building.id === building.id)
                let itemRows = []
                if (items.length > 0) {
                    items.forEach(function (item) {
                        itemRows.push({
                            id: item.id,
                            apartmentNumber: item.apartment_number,
                            usefulSurface: item.useful_surface,
                            terraceSurface: item.terrace_surface,
                            gardenSurface: item.garden_surface,
                            price: item.price,
                            credit_price: item.credit_price,
                            status: item.status,
                            showStatusForClients: item.show_status_for_clients ? true : false,
                            showStatusForAgencies: item.show_status_for_agencies ? true : false,
                            highlighted: item.id === vm.toEditItemId ? true : false
                        })
                        if (item.id === vm.toEditItemId) {
                            buildingFormat.isActive = true;
                            this.activeTab = buildingFormat;
                        }
                    })
                }
                buildingFormat.levels.push({
                    title: level ? level.name : '',
                    ord: level ? level.sort_order : 0,
                    id: level ? level.id : '',
                    itemRows: itemRows
                })
            });
            vm.buildings.push(buildingFormat)
        });
        // if (this.buildings.length > 0) {
        //     this.setActive(this.buildings[0]);
        // }
    },
    methods: {
        setActive: function (building) {
            let self = this;
            building.isActive = true;
            this.activeTab = building;
            this.buildings.forEach(function (building) {
                if (building.id !== self.activeTab.id) {
                    building.isActive = false;
                }
            });
        },
        buildingOffers(building) {
            let selectedBuilding = this.buildings.filter(i => i.id === building.id)[0];
            let count = 0;
            if(selectedBuilding) {
                for (let i = 0; i < selectedBuilding.levels.length; i++) {
                    count += selectedBuilding.levels[i].itemRows.length;
                }
            }
            return count;
        },
        addItemRow: function (itemRows) {
            itemRows.push({
                apartmentNumber: '',
                usefulSurface: this.model.useful_surface,
                terraceSurface: this.model.terrace_surface,
                gardenSurface: this.model.garden_surface,
                price: this.model.price,
                credit_price: this.model.credit_price,
                status: 'available',
                showStatusForClients: true,
                showStatusForAgencies: false
            });
        },
        removeItemRow: function (index, itemRows) {
            itemRows.splice(index, 1);
        },
        save() {
            let vm = this
            window.axios.post(`/developer/model-items-edit/${this.model.id}`, this.buildings)
                .then(function () {
                    window.Swal.fire({
                        html: 'Modificarile au fost efectuate cu succes.',
                        icon: 'success',
                        timer: 2000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(() => {
                        if (vm.model.type === 'commercial') {
                            window.location.href = `/developer/project/${vm.project.id}?tab=space`
                        } else {
                            window.location.href = `/developer/project/${vm.project.id}?tab=apartment`
                        }
                    })
                })
                .catch(function (err) {
                    window.showError(err)
                });
        }
    }
}
</script>
<style scoped>
    .customBlocksTabsContainer {
        margin-top: 20px;
        margin-bottom: 20px;
        border-bottom: 1px solid #dee2e6 !important;
    }
    .customBlocksTabsContainer .blocks-tabs {
        margin-top: 0;
        margin-bottom: 0;
        border-bottom: none !important;
    }
    .customBlocksTabsContainer .blocks-tabs p a.active {
        background-color: #d4d4d4;
    }
    .remove-field-btn {
        right: -15px;
        top: 40px;
    }
    h6 .fa-plus-circle {
        color: #00c851;
    }
    h6 .fa-trash-alt {
        color: #C05621;
    }
</style>